import { Fragment } from "react";
import GetStarted from "./GetStarted";
import HeroSection from "./HeroSection";
import HowItWorks from "./HowItWorks";
import RecentWork from "./RecentWork";

const Home = () => {
  return (
    <Fragment>
      <HeroSection />
      <HowItWorks />
      <GetStarted />
      <RecentWork />
    </Fragment>
  );
};

export default Home;
